import { render, staticRenderFns } from "./add-research-group.html?vue&type=template&id=34c61be1&scoped=true&"
import script from "./add-research-group.js?vue&type=script&lang=js&"
export * from "./add-research-group.js?vue&type=script&lang=js&"
import style0 from "./add-research-group.scss?vue&type=style&index=0&id=34c61be1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c61be1",
  null
  
)

export default component.exports